import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-yesno-answer',
  templateUrl: './yesno-answer.component.pug',
  styleUrls: ['./yesno-answer.component.scss'],
  standalone: false
})
export class YesnoAnswerComponent implements OnInit {
  @Input() options: any;
  constructor() { }

  ngOnInit(): void {
  }

}
